import { Formik } from "formik";
import {
  MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItem,
  IdentityMelcoAnalyticsModelsWidgetListItem,
} from "melco-shared-logic";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { DisplayUserWizardForm } from "./DisplayUserWizardForm";

type UserWizardFormProps = {
  userUserWizards: MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItem;

  referencesUserWizardDrawer: DrawerType;
  selectedUserId: string;
  onCloseUserWizardsDrawer: () => void;
};

type UserWizardFormValueType = {
  wizard_list: IdentityMelcoAnalyticsModelsWidgetListItem[];
};

export const wizardToInitialValues = (
  wizard: MelcoModelsGenericList1MelcoAnalyticsModelsUserWidgetListItem
) => {
  const { list } = wizard;

  const initialValues: UserWizardFormValueType = {
    wizard_list: list ?? [],
  };

  return initialValues;
};
export const UserWizardForm: React.FC<UserWizardFormProps> = ({
  selectedUserId,
  userUserWizards,
  onCloseUserWizardsDrawer,
  referencesUserWizardDrawer,
}) => {
  const initialValues = wizardToInitialValues(userUserWizards);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => {}}
      enableReinitialize
    >
      <DirtyFormPrompt>
        <DisplayUserWizardForm
          //userUserWizards={userUserWizards}
          onCloseWizardsDrawer={onCloseUserWizardsDrawer}
          referencesWizardDrawer={referencesUserWizardDrawer}
          selectedUserId={selectedUserId}
        />
      </DirtyFormPrompt>
    </Formik>
  );
};
